module.exports = "<template>\r\n\t<div class=\"splash\">\r\n\t\t<div class=\"message\">almost there...</div>\r\n\t</div>\r\n</template>";